export class BlacklistCandidaturaCsvDTO{
    constructor(
        public login?: string,
        public candidaturaId?: number,
    ){}
}
